export default "__VITE_ASSET__B8eXlx8E__"